import React, { createContext, useContext, useState } from "react";
import { TooltipProvider } from "hardcover-ui/components/Tooltip";
import { ChartTheme } from "./theme/chartColors";
import { usePage } from "@inertiajs/react";
import Text from "hardcover-ui/components/Text";
import { UserStatsPageProps } from "pages/clientverse/users/stats/index.props";
// import { useStatPeriod } from "./StatPeriodContext";
import SummaryStat from "./statComponents/SummaryStat";
import BooksReadStat from "./statComponents/BooksReadStat";
import PagesReadStat from "./statComponents/PagesReadStat";
import ReadingPaceStat from "./statComponents/ReadingPaceStat";
import YearlyReadingStat from "./statComponents/YearlyReadingStat";
import MostReadGenreStat from "./statComponents/FictionVsNonFiction";
import ReadingFormatStat from "./statComponents/ReadingFormatStat";
import GenreBreakdownStat from "./statComponents/GenreBreakdownStat";
import MoodBreakdownStat from "./statComponents/MoodBreakdownStat";
import ReadingGraphStat from "./statComponents/ReadingGraphStat";
import BooksByRatingStat from "./statComponents/BooksByRatingStat";
import BooksByPageCountStat from "./statComponents/BooksByPageCountStat";
import MostReadAuthorsStat from "./statComponents/MostReadAuthorsStat";
import LibraryBreakdownStat from "./statComponents/LibraryBreakdownStat";
import OwnedBooksStat from "./statComponents/OwnedBooksStat";
// import GenreMoodHeatmapStat from "./statComponents/GenreMoodHeatmapStat";
// import RatedHigherStat from "./statComponents/RatedHigherStat";
// import RatedLowerStat from "./statComponents/RatedLowerStat";
// import MostSavesStat from "./statComponents/MostSavesStat";
// import TopLikedReviewStat from "./statComponents/TopLikedReviewStat";
// import MostPopularBookStat from "./statComponents/MostPopularBookStat";
// import LeastPopularBookStat from "./statComponents/LeastPopularBookStat";
// import AverageWaitingTimeStat from "./statComponents/AverageWaitingTimeStat";
// import MostReferredReadersStat from "./statComponents/MostReferredReadersStat";

// TODO: #1496 - Add LibrarianEditsStat
// import LibrarianEditsStat from "./statComponents/LibrarianEditsStat";
// import PacePredictionStat from "./statComponents/PacePredictionStat";
// import ReadingPulseAnalysis from "./statComponents/ReadingPulseAnalysis";
// import SeriesProgressStat from "./statComponents/SeriesProgressStat";
// import PublishingCountriesStat from "./statComponents/PublishingCountriesStat";
// import PublishingYearsStat from "./statComponents/PublishingYearsStat";

interface ChartThemeContextType {
  theme: ChartTheme;
  setTheme: (theme: ChartTheme) => void;
}

export const ChartThemeContext = createContext<ChartThemeContextType>({
  theme: "colorful",
  setTheme: () => {},
});

export function useChartTheme() {
  return useContext(ChartThemeContext);
}

export default function StatsOverview() {
  const [chartTheme, setChartTheme] = useState<ChartTheme>("colorful");
  const { stats } = usePage<UserStatsPageProps>().props;

  if (!stats) {
    return (
      <div className="flex items-center justify-center h-64">
        <Text>No stats data available</Text>
      </div>
    );
  }

  return (
    <ChartThemeContext.Provider
      value={{ theme: chartTheme, setTheme: setChartTheme }}
    >
      <TooltipProvider>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 py-4">
          <SummaryStat size="xl" />
          <BooksReadStat size="xl" />
          <PagesReadStat size="xl" />
          <ReadingPaceStat size="xl" />
          <YearlyReadingStat size="xl" />
          <ReadingGraphStat size="xl" />
          <MostReadGenreStat size="md" />
          <ReadingFormatStat size="md" />
          <GenreBreakdownStat size="md" />
          <MoodBreakdownStat size="md" />
          <BooksByRatingStat size="md" />
          <BooksByPageCountStat size="md" />
          <MostReadAuthorsStat size="xl" />
          <LibraryBreakdownStat size="md" />
          <OwnedBooksStat size="md" />
          {/* 
          <GenreMoodHeatmapStat
            size="xl"
            selectedPeriod={selectedPeriod}
            customDateRange={customDateRange}
          />
          <RatedHigherStat
            size="md"
            selectedPeriod={selectedPeriod}
            customDateRange={customDateRange}
          />
          <RatedLowerStat
            size="md"
            selectedPeriod={selectedPeriod}
            customDateRange={customDateRange}
          />
          <MostSavesStat
            size="md"
            selectedPeriod={selectedPeriod}
            customDateRange={customDateRange}
          />
          <TopLikedReviewStat
            size="md"
            selectedPeriod={selectedPeriod}
            customDateRange={customDateRange}
          />
          <MostPopularBookStat
            size="sm"
            selectedPeriod={selectedPeriod}
            customDateRange={customDateRange}
          />
          <LeastPopularBookStat
            size="sm"
            selectedPeriod={selectedPeriod}
            customDateRange={customDateRange}
          />
          <AverageWaitingTimeStat
            size="sm"
            selectedPeriod={selectedPeriod}
            customDateRange={customDateRange}
          />
          <PacePredictionStat
            size="sm"
            selectedPeriod={selectedPeriod}
            customDateRange={customDateRange}
          />
          <MostReferredReadersStat
            size="md"
            selectedPeriod={selectedPeriod}
            customDateRange={customDateRange}
          />
          <LibrarianEditsStat
            size="md"
            selectedPeriod={selectedPeriod}
            customDateRange={customDateRange}
          />
          <ReadingPulseAnalysis
            size="xl"
            selectedPeriod={selectedPeriod}
            customDateRange={customDateRange}
          />
          <PublishingYearsStat
            size="xl"
            selectedPeriod={selectedPeriod}
            customDateRange={customDateRange}
          />
          <PublishingCountriesStat
            size="xl"
            selectedPeriod={selectedPeriod}
            customDateRange={customDateRange}
          />
          <SeriesProgressStat /> */}
        </div>
      </TooltipProvider>
    </ChartThemeContext.Provider>
  );
}
